var StoryTeaserLayout;
(function (StoryTeaserLayout) {
    StoryTeaserLayout["VARIANT_A"] = "story-teaser--variant-a";
    StoryTeaserLayout["VARIANT_B"] = "story-teaser--variant-b";
    StoryTeaserLayout["VARIANT_C"] = "story-teaser--variant-c";
})(StoryTeaserLayout || (StoryTeaserLayout = {}));
var StoryType;
(function (StoryType) {
    StoryType["DEFAULT"] = "default";
    StoryType["PODCAST"] = "podcast";
    StoryType["SERIES"] = "series";
    StoryType["SLIDESHOW"] = "slideshow";
    StoryType["VIDEO"] = "video";
})(StoryType || (StoryType = {}));
const IconVariant = {
    [StoryType.DEFAULT]: null,
    [StoryType.PODCAST]: 'podcasts',
    [StoryType.SERIES]: 'series',
    [StoryType.SLIDESHOW]: 'book',
    [StoryType.VIDEO]: 'play',
};

export { IconVariant as I, StoryTeaserLayout as S, StoryType as a };

//# sourceMappingURL=roche-story-teaser.types.js.map